import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import { Alert } from "react-bootstrap";
import { useAuth } from "../context/AuthProvider";
import { Link } from 'react-router-dom'


function Connexion() {

      const [isChecked, setChecked] = useState(false);

      const handleCheckboxChange = () => {
        setChecked(!isChecked);
      };    
  
      const emailRef = useRef(null);
      const passwordRef = useRef(null);
      // const [errorMsg, setErrorMsg] = useState("");
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();
      const { login, user } = useAuth();

      const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          // setErrorMsg("");
          setLoading(true);
          // console.log("data : ", emailRef.current.value, passwordRef.current.value)
          if (!passwordRef.current?.value || !emailRef.current?.value) {
            // setErrorMsg("Please fill in the fields");
            console.log("Please fill in the fields")
            return;
          }
          const {
            data: { user, session },
            error
          } = await login(emailRef.current.value, passwordRef.current.value);
          if (error) console.log(error.message) // setErrorMsg(error.message);
          if (user && session) {
            navigate("/");
          }
        } catch (error) {
          // setErrorMsg("Email or Password Incorrect");
          console.log("Email or Password Incorrect")
        }
        setLoading(false);
      };

    return (
      <>
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form className="space-y-6" onSubmit={handleSubmit} method="POST">
              <div>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                  Adresse email
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    ref={emailRef}
                    autoComplete="email"
                    required
                    className="block w-full py-1.5 text-gray-900 rounded-md border border-gray-300 shadow-sm sm:text-md focus:outline-none"
                  />
                </div>
              </div>
  
              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                    Mot de passe
                  </label>
                </div>
                <div className="mt-2">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    ref={passwordRef}
                    autoComplete="current-password"
                    required
                    className="block w-full py-1.5 text-gray-900 rounded-md border border-gray-300 shadow-sm sm:text-md focus:outline-none"
                  />
                </div>
              </div>

              <div>
                <input
                  type="checkbox"
                  id="myCheckbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  className="form-checkbox rounded-md border border-gray-300 h-5 w-5 text-indigo-600"
                />
                <label htmlFor="myCheckbox" className="ml-2 text-sm text-gray-700">
                  <span>J'accepte les </span>
                  <span> <Link to="/cgu" className="hover:underline"> conditions générales d'utilisation</Link></span>
                </label>
              </div>
  
              <div>
              {isChecked && (
                  <button
                    disabled={loading}
                    type="submit"
                    className="flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                  >
                    Se connecter
                  </button>
                )}
              </div>
            </form>

          </div>
        </div>
      </>
    )
  }

  export default Connexion
  